import createEntry from '../../common/utils/api/index.tsx';
import { props } from './constants.tsx';

type ProjectKey = string;

export default createEntry<{
	name: string;
	id: string;
	self: string;
	projectKey: ProjectKey;
}>(props);
